export const getCollections = async (uri, apiKey) => {
  const options = {
    method: "get",
    headers: {
      Authorization: `Bearer ${apiKey}`,
      Accept: "application/json",
    },
  };

  try {
    const resp = (await fetch(uri, options).then((res) => res.json())).data;
    return resp || null;
  } catch (e) {
    console.log(e);
    return null;
  }
};